import { render, staticRenderFns } from "./agreement-limit-history-drawer.component.vue?vue&type=template&id=12cf08b9&scoped=true&"
import script from "./agreement-limit-history-drawer.component.vue?vue&type=script&lang=ts&"
export * from "./agreement-limit-history-drawer.component.vue?vue&type=script&lang=ts&"
import style0 from "./agreement-limit-history-drawer.component.vue?vue&type=style&index=0&id=12cf08b9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf08b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VNavigationDrawer,VRow})
